import React from 'react'
import { observer } from 'mobx-react'
import { useStores } from 'presentation/hooks/use-stores'
import HeadingNew from 'presentation/shared/components/HeadingNew'
import ScheduleRequestsDataGrid from 'presentation/hospital/components/Tables/ScheduleRequestsDataGrid'
import * as S from './styles'

const HospitalScheduleSurgeryRequestsLayout = observer(() => {
  const currentHospital = useStores().currentHospital.actualHospital

  return (
    <S.Wrapper>
      <HeadingNew size="xlarge" color="primary600" lineHeight="large">
        Solicitações de agendamentos
        {/* {currentHospital?.friendly_name} */}
      </HeadingNew>
      <ScheduleRequestsDataGrid
        currentHospitalId={currentHospital!.hospital_id}
      />
    </S.Wrapper>
  )
})

export default HospitalScheduleSurgeryRequestsLayout
